var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-card',[_vm._v("\n        Esta es la página de Inicio\n      ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }